<template>
  <q-list link class="dashboard-widget-menu">
    <q-item v-if="widgetChartMenu.length > 0"
            v-for="menu in widgetChartMenu"
            v-close-overlay
            :key="menu.key"
            @click.native="menu.click($event, $parent)"
    >
      <q-item-side :class="menu.icon"></q-item-side>
      <q-item-main>{{menu.label}}</q-item-main>
    </q-item>
    <q-item v-if="widgetBasicMenu.length > 0"
            v-for="menu in widgetBasicMenu"
            v-close-overlay
            :key="menu.key"
            @click.native="menu.click($event, $parent)"
    >
      <q-item-side :class="menu.icon"></q-item-side>
      <q-item-main>{{menu.label}}</q-item-main>
    </q-item>
    <q-item-separator v-if="widgetCustomMenu.length > 0"/>
    <q-item v-if="widgetCustomMenu.length > 0"
            v-for="menu in widgetCustomMenu"
            v-close-overlay
            :key="menu.key"
            @click.native="menu.click($event, $parent)"
    >
      <q-item-side :class="menu.icon"></q-item-side>
      <q-item-main>{{menu.label}}</q-item-main>
    </q-item>
  </q-list>
</template>

<script>
  export default {
    name: 'GridWidgetMenu',
    components: {},
    directives: {},
    mixins: [],
    data () {
      return {}
    },
    props: {
      widgetBasicMenu: {
        type: Array,
        default () {
          return []
        }
      },
      widgetChartMenu: {
        type: Array,
        default () {
          return []
        }
      },
      widgetCustomMenu: {
        type: Array,
        default () {
          return []
        }
      }
    },
    computed: {},
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {},
    watch: {}
  }
</script>

<style scoped>
  .dashboard-widget-menu {
    width: 190px;
    cursor: pointer;
  }
</style>
